import {
  keepPreviousData,
  type UseQueryOptions,
  type UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  getLocksAPI,
  type Lock,
  type LockListParams,
  unlockLockAPI,
} from "@/apis/lock/lock-apis";
import { queryKeys } from "./keys";
import type { PaginatedResponse } from "./types";

type LockQueryOptions = Omit<
  UseQueryOptions<PaginatedResponse<Lock>>,
  "queryKey" | "queryFn"
>;

export function useLocks(
  params: LockListParams = {},
  options: LockQueryOptions = {}
): UseQueryResult<PaginatedResponse<Lock>> {
  return useQuery({
    queryKey: queryKeys.locks.list(params),
    queryFn: () => getLocksAPI(params),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useUnlockLock() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => unlockLockAPI(id),
    onSuccess: () => {
      // Unlock affects lock state, invalidate all list queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.locks.all,
        predicate: (query) => query.queryKey[1] === "list",
      });
    },
  });
}
